import { useDispatch, useSelector } from "react-redux";
import { startConsignProperty } from "../../actions/properties";
import { propertyActions } from "../../store/propertySlice";

function NewConsignForm() {
  const dispatch = useDispatch();

  const name = useSelector((state) => state.property.consignProperty.name);
  const email = useSelector((state) => state.property.consignProperty.email);
  const phone = useSelector((state) => state.property.consignProperty.phone);
  const address = useSelector(
    (state) => state.property.consignProperty.address
  );
  const propertyType = useSelector(
    (state) => state.property.consignProperty.propertyType
  );
  const comments = useSelector(
    (state) => state.property.consignProperty.comments
  );

  const isLoading = useSelector(
    (state) => state.property.consignProperty.loading
  );
  const onName = (event) => {
    dispatch(propertyActions.setConsignPropertyName(event.target.value));
  };
  const onEmail = (event) => {
    dispatch(propertyActions.setConsignPropertyEmail(event.target.value));
  };
  const onPhone = (event) => {
    dispatch(propertyActions.setConsignPropertyPhone(event.target.value));
  };
  const onAddress = (event) => {
    dispatch(propertyActions.setConsignPropertyAddress(event.target.value));
  };
  const onPropertyType = (event) => {
    dispatch(
      propertyActions.setConsignPropertyPropertyType(event.target.value)
    );
  };
  const onComments = (event) => {
    dispatch(propertyActions.setConsignPropertyComments(event.target.value));
  };

  function onClickNewConsign() {
    const consign_data = {
      name: name,
      cellphone: phone,
      email: email,
      address: address,
      type_property: propertyType,
      desc: comments,
    };

    dispatch(startConsignProperty(consign_data));
  }

  return (
    <div>
      <section className="slice pt-0 sct-color-1">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group has-feedback">
                    <label htmlFor="" className="c-gray-light">
                      Nombre
                    </label>
                    <input
                      type="text"
                      value={name}
                      onChange={onName}
                      className="form-control form-control-lg"
                    />
                    <span
                      className="glyphicon form-control-feedback"
                      aria-hidden="true"
                    ></span>
                    <div className="help-block with-errors"></div>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group has-feedback">
                    <label htmlFor="" className="c-gray-light">
                      Telefono o celular
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-lg"
                      value={phone}
                      onChange={onPhone}
                    />
                    <span
                      className="glyphicon form-control-feedback"
                      aria-hidden="true"
                    ></span>
                    <div className="help-block with-errors"></div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div className="form-group has-feedback">
                    <label htmlFor="" className="c-gray-light">
                      Correo
                    </label>
                    <input
                      type="email"
                      className="form-control form-control-lg"
                      value={email}
                      onChange={onEmail}
                    />
                    <span
                      className="glyphicon form-control-feedback"
                      aria-hidden="true"
                    ></span>
                    <div className="help-block with-errors"></div>
                  </div>
                </div>
                <div className="col-sm-6"></div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div className="form-group has-feedback">
                    <label htmlFor="" className="c-gray-light">
                      Direccion
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-lg"
                      value={address}
                      onChange={onAddress}
                      required=""
                    />
                    <span
                      className="glyphicon form-control-feedback"
                      aria-hidden="true"
                    ></span>
                    <div className="help-block with-errors"></div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group has-feedback">
                    <label htmlFor="" className="c-gray-light">
                      Tipo propiedad
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-lg"
                      value={propertyType}
                      onChange={onPropertyType}
                    />
                    <span
                      className="glyphicon form-control-feedback"
                      aria-hidden="true"
                    ></span>
                    <div className="help-block with-errors"></div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <div className="form-group has-feedback">
                    <label htmlFor="" className="c-gray-light">
                      Describenos las caracteristicas de tu propiedad
                    </label>
                    <textarea
                      name="message"
                      className="form-control no-resize"
                      rows="5"
                      value={comments}
                      onChange={onComments}
                    ></textarea>
                    <span
                      className="glyphicon form-control-feedback"
                      aria-hidden="true"
                    ></span>
                    <div className="help-block with-errors"></div>
                  </div>
                </div>
              </div>

              <div className="">
                <button
                  disabled={isLoading || !name || !email || !phone || !address}
                  className="btn btn-styled btn-base-2 mt-4 consign-button"
                  onClick={onClickNewConsign}
                >
                  Enviar
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default NewConsignForm;
